import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { EmptyMessageComponent } from '@jms/ui/ui.empty.message';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { resolveBoardEmptyState } from '../../model/entity.board.empty';
import { EntityBoardStore } from '../../state';
import { boardEmptyBridgeStyles, boardEmptyStyleId } from './board.empty.theme';

/**
 * Shared board empty state: AG Grid no-rows overlay and card/kanban host.
 * Copy comes from manifest `board.*.empty`, else metadata displayName.
 */
@Component({
  selector: 'board-empty',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [EmptyMessageComponent],
  styleUrls: ['./board.empty.component.less'],
  template: `
    <empty-message [message]="$state().title" [icon]="$state().icon ?? ''" [iconSize]="'32px'" [displayIcon]="!!$state().icon" />
    @if ($state().description; as description) {
      <span class="description">{{ description }}</span>
    }
  `,
})
export class BoardEmptyComponent implements INoRowsOverlayAngularComp {

  /** Table-only recovery hint; no-record and filter-empty copy remain unchanged elsewhere. */
  public readonly $noColumns = input(false, { alias: 'noColumns' });

  private readonly document = inject(DOCUMENT);
  private readonly store = inject(EntityBoardStore);

  public constructor() {

    DesignSystem.Mount(this.document, boardEmptyStyleId, boardEmptyBridgeStyles);
  }

  protected readonly $state = computed(() => resolveBoardEmptyState({
    noColumns: this.$noColumns(),
    empty: this.store.$context()?.empty,
    displayName: this.store.$metadata()?.displayName ?? this.store.$metadata()?.name,
    filtered: !!this.store.$search()?.trim() || (this.store.$filterCount() ?? 0) > 0,
  }));

  public agInit(): void { }

  public refresh(): boolean {

    return true;
  }
}
